import BonkIcon from '../assets/bonk_fun.png';

export function LetsBonkIcon({ className = '' }: { className?: string }) {
    return <img className={'size-[28px] ' + className} src={BonkIcon} alt='Bonk Icon' />;
}
